import { Link } from 'react-router-dom';

const links = [
  { label: 'X / Twitter', href: 'https://x.com/dumbverse' },
  { label: 'Instagram', href: 'https://instagram.com/dumbverse.app' },
  { label: 'LinkedIn', href: 'https://linkedin.com/company/dumbverse' },
  { label: 'YouTube', href: 'https://youtube.com/@thedumbverse' },
  { label: 'Reddit', href: 'https://reddit.com/r/dumbverse' },
  { label: 'Discord', href: '#' },
];

const pages = [
  { label: 'The Council', to: '/council' },
  { label: 'Dumb ideas that worked', to: '/dumb-ideas' },
  { label: 'The dumbest page on the internet', to: '/dumb' },
];


const Footer = () => (
  <footer className="py-16 px-6 border-t border-border" role="contentinfo">
    <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-12">
      <div>
        <p className="font-bebas text-2xl text-foreground mb-2">🌍 DUMBVERSE</p>
        <p className="font-mono text-sm text-muted-foreground">Every dumb idea deserves its own universe.</p>
        <a href="mailto:universe@dumbverse.app" className="font-mono text-sm text-muted-foreground hover:text-foreground transition-colors mt-2 inline-block">universe@dumbverse.app</a>
      </div>
      <div className="flex flex-col gap-2">
        {links.map(link => (
          <a
            key={link.label}
            href={link.href}
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm font-mono text-muted-foreground hover:text-foreground transition-colors"
          >
            {link.label}
          </a>
        ))}
      </div>
      <nav className="flex flex-col gap-2" aria-label="Explore Dumbverse">
        {pages.map(page => (
          <Link
            key={page.to}
            to={page.to}
            className="text-sm font-mono text-muted-foreground hover:text-foreground transition-colors"
          >
            {page.label}
          </Link>
        ))}
      </nav>
      <div className="md:text-right">
        <p className="text-sm font-mono text-muted-foreground">© 2026 Dumbverse</p>
        <p className="text-sm font-mono text-muted-foreground mt-1">Privacy Policy | Terms of Service</p>
        <p className="text-sm font-mono text-muted-foreground mt-1">dumbverse.app</p>
      </div>
    </div>
  </footer>
);

export default Footer;
